"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DismissButton = exports.Body = exports.Header = exports.Dialogue = exports.Mask = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Constant = require("../Constant");

var _util = require("../Util/util");

var _Button = require("../Button");

function _templateObject13() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  height: 2.4rem;\n  width: 2.4rem;\n  padding: 4px;\n  z-index: 1;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteral2.default)([""]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 10px;\n\n  h1,\n  h2,\n  h3 {\n    color: ", ";\n    font-size: 2.4rem;\n    margin: 0;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n        max-width: ", ";\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  // cover everything by default on mobile\n  width: 100%;\n  margin: 15px;\n  padding: 30px;\n  background-color: ", ";\n  max-height: calc(100vh - 20px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  ", ";\n  /* this border defines the space for Windows high contrast users. Without the border, the modal flows into the surrounding content */\n  border: 1px solid transparent;\n\n  @media (min-width: ", "px) {\n    width: ", ";\n    ", "\n  }\n\n  @media (min-width: ", "px) {\n    width: ", ";\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n    animation: ", ";\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n      animation: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", " .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) 0s 1 forwards;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(0);\n    opacity: 0;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", " .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) 0s 1 forwards;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  0% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  outline: 0;\n  overflow: hidden;\n  background-color: ", ";\n  transition: opacity 0.5s;\n  opacity: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  z-index: 1000;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: ", ";\n  justify-content: center;\n  align-items: top;\n  transform: scale(", ");\n  transition: transform ", ";\n\n  @media (min-width: ", "px) {\n    align-items: center;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = _styledComponents.default.div(_templateObject(), function (props) {
  return props.isOpen || props.animating ? 'flex' : 'none';
}, function (props) {
  return props.isOpen ? 1 : 0;
}, function (props) {
  return props.isOpen ? '0s' : '0s 0.5s';
}, _Constant.Width.SM);

var Mask = _styledComponents.default.div(_templateObject2(), _Constant.Color.BLACK, function (props) {
  return props.isOpen ? 0.85 : 0;
});

exports.Mask = Mask;

var smWidth = function smWidth(col) {
  var size = 100;

  switch (col) {
    case 'sm':
      size = 70;
      break;

    case 'md':
      size = 80;
      break;

    case 'lg':
      size = 90;
      break;

    default:
      break;
  }

  return "".concat(size, "%");
};

var mdWidth = function mdWidth(col) {
  var size = 100;

  switch (col) {
    case 'sm':
      size = 40;
      break;

    case 'md':
      size = 60;
      break;

    case 'lg':
      size = 80;
      break;

    default:
      break;
  }

  return "".concat(size, "%");
};

var blowUpModalIn = (0, _styledComponents.keyframes)(_templateObject3());
var blowUpModalInRule = (0, _styledComponents.css)(_templateObject4(), blowUpModalIn);
var blowUpModalOut = (0, _styledComponents.keyframes)(_templateObject5());
var blowUpModalOutRule = (0, _styledComponents.css)(_templateObject6(), blowUpModalOut);

var animationStyle = function animationStyle(opening) {
  if (opening) return (0, _styledComponents.css)(_templateObject7(), blowUpModalInRule);
  return (0, _styledComponents.css)(_templateObject8(), blowUpModalOutRule);
}; // px is used with padding inside the Dialogue because it has limited space to grow when resized


var Dialogue = _styledComponents.default.div(_templateObject9(), _Constant.Color.WHITE, function (props) {
  return animationStyle(props.opening);
}, _Constant.Width.SM, function (props) {
  return smWidth(props.size);
}, function (_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth && (0, _styledComponents.css)(_templateObject10(), "".concat(maxWidth).concat(typeof maxWidth === 'number' ? 'px' : ''));
}, _Constant.Width.MD, function (props) {
  return mdWidth(props.size);
}); // TODO: determine if we should provide classes or enforce modal header/body setup


exports.Dialogue = Dialogue;

var Header = _styledComponents.default.header(_templateObject11(), _Constant.Color.DARK_GREY_2); // Used in MultiProductModal.js


exports.Header = Header;

var Body = _styledComponents.default.div(_templateObject12());

exports.Body = Body;
var DismissButton = (0, _styledComponents.default)(_Button.DismissButton)(_templateObject13());
exports.DismissButton = DismissButton;

var Modal = function Modal(_ref2) {
  var buttonProps = _ref2.buttonProps,
      children = _ref2.children,
      className = _ref2.className,
      closable = _ref2.closable,
      dialogueProps = _ref2.dialogueProps,
      header = _ref2.header,
      isOpen = _ref2.isOpen,
      maxWidth = _ref2.maxWidth,
      onClose = _ref2.onClose,
      size = _ref2.size,
      description = _ref2.description,
      role = _ref2.role;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      animating = _useState2[0],
      setAnimating = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      opening = _useState4[0],
      setOpening = _useState4[1];

  var modalRef = (0, _react.useRef)(null);
  var focusTarget = (0, _react.useRef)(null);
  var firstElement = (0, _react.useRef)(null);
  var lastElement = (0, _react.useRef)(null);
  var handleFocus = (0, _react.useCallback)(function () {
    focusTarget.current && focusTarget.current.focus();
  }, [focusTarget]);
  var handleTabKey = (0, _react.useCallback)(function (e) {
    if (!e.shiftKey && document.activeElement === lastElement.current) {
      firstElement.current.focus();
      e.preventDefault();
    }

    if (e.shiftKey && document.activeElement === firstElement.current) {
      lastElement.current.focus();
      e.preventDefault();
    }
  }, []);
  var handleClose = (0, _react.useCallback)(function () {
    onClose();
    handleFocus();
  }, [onClose, handleFocus]);
  var keyListenerMap = (0, _react.useMemo)(function () {
    return new Map([[27, handleClose], [9, handleTabKey]]);
  }, [handleClose, handleTabKey]);
  var keyListener = (0, _react.useCallback)(function (e) {
    var listener = keyListenerMap.get(e.keyCode);
    return listener && listener(e);
  }, [keyListenerMap]);
  var hideBodyOverflow = (0, _react.useCallback)(function () {
    return Object.assign(document.body.style, {
      overflow: 'hidden',
      position: 'fixed'
    });
  }, []);
  var showBodyOverflow = (0, _react.useCallback)(function () {
    return Object.assign(document.body.style, {
      overflow: 'visible',
      position: 'static'
    });
  }, []);
  (0, _react.useEffect)(function () {
    var didCancel = false;
    var focusableElements = modalRef.current.querySelectorAll(['a[href]', 'button', 'textarea', 'input[type="text"]', 'input[type="radio"]', 'input[type="checkbox"]', 'select', 'iframe']);
    firstElement.current = focusableElements[0];
    lastElement.current = focusableElements[focusableElements.length - 1];
    document.addEventListener('keydown', keyListener);
    setAnimating(true);
    window.setTimeout(function () {
      if (!didCancel) setAnimating(false);
    }, 500);
    return function () {
      didCancel = true;
      showBodyOverflow();
      document.removeEventListener('keydown', keyListener);
    };
  }, [handleFocus, keyListener, showBodyOverflow]);
  (0, _react.useEffect)(function () {
    if (isOpen) {
      focusTarget.current = document.activeElement;
      setOpening(true);
      firstElement.current && firstElement.current.focus();
      hideBodyOverflow();
    } else {
      focusTarget.current = null;
      setOpening(false);
      showBodyOverflow();
    }
  }, [isOpen, showBodyOverflow, hideBodyOverflow]);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    isOpen: isOpen,
    animating: animating,
    className: className,
    role: role,
    "aria-atomic": role === 'alert' ? 'false' : null,
    "aria-modal": role === 'dialog' ? 'true' : null,
    "aria-label": header || description // use of aria-hidden here required to hide the modal content from the accessibility tree as VoiceOver was placing focus in the closed modals upon page load and would repeat the modal content making it difficult to impossible to listen to the page content. Using aria-hidden on elements with focusable content will create a 'needs review' flag when running an Axe audit, however, the modal content renders with `display: none` when the modal is closed, so technically, this use of aria-hidden passes the use case examples as found here (https://dequeuniversity.com/rules/axe/4.0/aria-hidden-focus?application=AxeChrome)
    ,
    "aria-hidden": !isOpen || null
  }, /*#__PURE__*/_react.default.createElement(Mask, {
    isOpen: isOpen
  }), /*#__PURE__*/_react.default.createElement(Dialogue, (0, _extends2.default)({
    size: size,
    maxWidth: maxWidth,
    opening: opening,
    ref: modalRef
  }, dialogueProps), closable && /*#__PURE__*/_react.default.createElement(DismissButton, (0, _extends2.default)({
    onClick: handleClose
  }, buttonProps)), header && /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement("h2", null, header)), /*#__PURE__*/_react.default.createElement(Body, {
    className: className
  }, children)));
};

var ModalContainer = function ModalContainer(props) {
  return _util.isServer ? null : /*#__PURE__*/_react.default.createElement(Modal, props);
};

ModalContainer.displayName = 'Modal';
ModalContainer.propTypes = {
  /** On object of pass through props for the button  */
  buttonProps: _propTypes.default.object,

  /** The modal content  */
  children: _propTypes.default.node.isRequired,

  /** class name string */
  className: _propTypes.default.string,

  /** Whether or not the dismiss button should be rendered  */
  closable: _propTypes.default.bool,

  /** On object of pass through props for the dialogue  */
  dialogueProps: _propTypes.default.object,

  /** Text to display in the modal header */
  header: _propTypes.default.string,

  /** Whether or not the modal is open */
  isOpen: _propTypes.default.bool,

  /** The maximum width of the modal  */
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** A function to run when the dismiss button is clicked  */
  onClose: _propTypes.default.func,

  /** Specifies the size of the dialogue */
  size: _propTypes.default.oneOf(['sm', 'md', 'lg']),

  /** PLEASE INCLUDE WHEN HEADER IS NOT USED! Provides a description of modal contents for screen readers in the event a header is not provided. */
  description: _propTypes.default.string,

  /** 'dialog' is used when the modal has focusable elements. 'alert' is used for static content. */
  role: _propTypes.default.oneOf(['dialog', 'alert'])
};
Modal.propTypes = ModalContainer.propTypes;
ModalContainer.defaultProps = {
  buttonProps: {},
  className: '',
  closable: true,
  dialogueProps: {},
  header: '',
  isOpen: false,
  maxWidth: 640,
  size: 'md',
  onClose: function onClose() {},
  description: '',
  role: 'dialog'
};
var _default = ModalContainer;
exports.default = _default;